import { Font } from '@react-pdf/renderer';
import React from 'react';
import { groupByAggregate } from '../../Helpers/Calculations';
import { allTabs } from '../Tabber';
import BerkeleyPdf from './BerkeleyPdf';
import robotoFont from './fonts/Roboto-Regular.ttf';
import GenericPdf from './GenericPdf';
import LashBmsPdf from './LashBmsPdf';
import MorphoSysPdf from './MorphoSysPdf';
import SpectrumPdf from './SpectrumPdf';

const MORPH_PROGRAM = 1328;
const BERKELEY_PROGRAM = 1385;
const TRIAL_CARD_BERKELEY_PROGRAM = 1624;
const LASH_BMS_PROGRAM = 1;
const LASH_EAGLE_PROGRAM = 1322;
const LASH_SPRYCEL_PROGRAM = 1697;
const SPECTRUM_PROGRAM = 1691;

const PdfForm = props => {
    const { form } = props;

    //start at fonts.google.com
    //use postman to query the font like so: https://fonts.googleapis.com/css?family=Castoro
    //copy the url from that query, family can be any unique string
    // //bold/italic fonts should be referenced separately
    Font.register({ family: 'RobotoRegular', src: robotoFont }); //the google api fonts don't support characters like ≥ or ≤
    Font.register({ family: 'RobotoBold', src: 'https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlvAw.ttf' });
    Font.register({ family: 'RobotoItalic', src: 'https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu52xP.ttf' });
    Font.register({ family: 'RobotoBoldItalic', src: 'https://fonts.gstatic.com/s/roboto/v27/KFOjCnqEu92Fr1Mu51TzBhc9.ttf' });

    const tabs = groupByAggregate(
        form.layout,
        'tab',
        g => {
            const first = g[0];
            return {
                key: first.tab,
                name: allTabs.find(tab => tab.key === first.tab)?.text,
                sections: g
            }
        });

    if (form.meta.assistanceProgramId === MORPH_PROGRAM) {
        return <MorphoSysPdf form={form} tabs={tabs} />
    }
    else if (form.meta.assistanceProgramId === BERKELEY_PROGRAM || form.meta.assistanceProgramId === TRIAL_CARD_BERKELEY_PROGRAM) {
        return <BerkeleyPdf form={form} tabs={tabs} />
    }
    else if (form.meta.assistanceProgramId === LASH_BMS_PROGRAM || form.meta.assistanceProgramId === LASH_EAGLE_PROGRAM || form.meta.assistanceProgramId === LASH_SPRYCEL_PROGRAM) {
        return <LashBmsPdf form={form} tabs={tabs} />
    }
    else if (form.meta.assistanceProgramId === SPECTRUM_PROGRAM) {
        return <SpectrumPdf form={form} tabs={tabs} />
    }
    else {
        return <GenericPdf form={form} tabs={tabs} />
    }
}

export default PdfForm;
